import * as actions from "./actions";

export default function emailsReducer(state = [], action) {
    switch (action.type) {

    case actions.SEND_EMAIL_SUCCESS:
    case actions.SEND_EMAIL_FAIL:
    {
        return action.payload;
    }
    default:
        return state;

    }
}
